import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";

/// Pages
import Error404 from "./common/Error404";

//Scroll To Top
import ScrollToTop from "./layouts/ScrollToTop";

import Dashboard from "./pages/Dashboard";

// AdminSetting
import Permission from "./pages/AdminManagment/CustomRules";
import AddPermission from "./pages/AdminManagment/CustomRules/AddRole";
import Admins from "./pages/AdminManagment/Admin";
import Notification from "./pages/Notification";
import PaymentLink from "./pages/PaymentLink";
import Users from "./pages/Users";
import AddNotification from "./pages/Notification/AddNotification";
import CategoryManagement from "./pages/CategoryManagement";
import Banner from "./pages/CMS/Banner";
import Products from "./pages/MarketPlace /Products";
import AddProduct from "./pages/MarketPlace /Products/AddProduct";
import AllBooking from "./pages/Booking/AllBooking";
import FAQs from "./pages/CMS/FAQs";
import Privacy from "./pages/CMS/Privacy";
import OnBoarding from "./pages/CMS/OnBoarding";
import Matches from "./pages/MarketPlace /Matches";
import AddMatches from "./pages/MarketPlace /Matches/AddMatches";
import Packages from "./pages/Packages";
import AddPackage from "./pages/Packages/AddPackage";
import UserReports from "./pages/Reports/UserReports";
import MatchesReports from "./pages/Reports/MatchesReports";
import PinMarketPlace from "./pages/MarketPlace /PinMarketPlace";
import BookingRequests from "./pages/Booking/BookingRequests";
import BookingReports from "./pages/Reports/BookingReports";
import Vendors from "./pages/Vendors";
import PopularVendors from "./pages/PopularVendors";
import AddOns from "./pages/AddOns";
import AddAddOns from "./pages/AddOns/AddAddOns";
import Reviews from "./pages/Review";
import Discount from "./pages/Discount";
import VendorsRequests from "./pages/VendorsRequests";
import VendorPackages from "./pages/VendorPackages";
import AddVendorPackage from "./pages/VendorPackages/AddPackage";
import VendorProducts from "./pages/VendorProducts";

const Markup = () => {
	const allroutes = [
		// Dashboard
		{ url: "/", component: <Dashboard /> },

		// Staff Managment
		{ url: "/admins", component: <Admins /> },
		{ url: "roles", component: <Permission /> },
		{ url: "roles/add_role", component: <AddPermission /> },
		{ url: "roles/:id", component: <AddPermission /> },

		// Category Managment
		{ url: "category-managment", component: <CategoryManagement /> },

		// Vendors
		{ url: "vendors", component: <Vendors /> },
		{ url: "popular-vendors", component: <PopularVendors /> },
		{ url: "vendors-requests", component: <VendorsRequests /> },

		// Market Place
		{ url: "products", component: <Products /> },
		{ url: "add-product", component: <AddProduct /> },
		{ url: "matches", component: <Matches /> },
		{ url: "matches/add-matches", component: <AddMatches /> },
		{ url: "pin-market-place", component: <PinMarketPlace /> },

		// Package
		{ url: "packages", component: <Packages /> },
		{ url: "add-package", component: <AddPackage /> },

		// Add Ons
		{ url: "add-ons", component: <AddOns /> },
		{ url: "add-add-ons", component: <AddAddOns /> },

		// Reviews
		{ url: "reviews", component: <Reviews /> },

		// Booking
		{ url: "bookings", component: <AllBooking /> },
		{ url: "booking-requests", component: <BookingRequests /> },

		{ url: "vendor/bookings", component: <AllBooking /> },
		{ url: "vendor/orders", component: <VendorPackages /> },
		{ url: "vendor/add-package", component: <AddVendorPackage /> },

		{ url: "vendor/products", component: <VendorProducts /> },
		// Users
		{ url: "/users", component: <Users /> },

		// Discount
		{ url: "/discount", component: <Discount /> },

		// Reports
		{ url: "/users-reports", component: <UserReports /> },
		{ url: "/matches-reports", component: <MatchesReports /> },
		{ url: "/booking-reports", component: <BookingReports /> },

		// CMS
		{ url: "banner", component: <Banner /> },
		{ url: "faqs", component: <FAQs /> },
		{ url: "privacy", component: <Privacy /> },
		{ url: "about", component: <Privacy /> },
		{ url: "contact", component: <Privacy /> },
		{ url: "terms", component: <Privacy /> },
		{ url: "onboarding", component: <OnBoarding /> },

		// Notification
		{ url: "notification", component: <Notification /> },
		{ url: "notification/add-notification", component: <AddNotification /> },
		{ url: "notification/edit-notification", component: <AddNotification /> },

		// Payment Link
		{ url: "payment-link", component: <PaymentLink /> },

		// Error
		{ url: "*", component: <Error404 /> },
	];

	return (
		<>
			<Routes>
				<Route path="page-error-404" element={<Error404 />} />
				<Route element={<MainLayout />}>
					{allroutes.map((data, i) => (
						<Route
							key={i}
							exact
							path={`${data.url}`}
							element={data.component}
						/>
					))}
				</Route>
			</Routes>
			<ScrollToTop />
		</>
	);
};

function MainLayout() {
	return (
		<div id="main-wrapper overflow-auto" className={`show `}>
			<Nav />
			<div
				className="content-body"
				style={{ minHeight: window.screen.height - 260 }}>
				<div className="container-fluid">
					<Outlet />
				</div>
			</div>
		</div>
	);
}

export default Markup;
